<div class="content-body">
    <app-breadcrumb [breadcrumb]="breadcrumbList" [addProperty]="checkAddInspection ? 'Create Inspection' : ''" (addEvent)="addTicketEvent($event)"> </app-breadcrumb>
    <div class="container-fluid">
        <div class="card">

            <div class="card-body p-0">
            <form [formGroup]="searchForm" (ngSubmit)="onSearch()" autocomplete="off">
                <div class="row">
                    <div class="col-md-2 mt-3 ps-4">
                        <div class="mb-3">
                            <input type="text" class="form-control input-default search-textbox-height" placeholder="Name" formControlName="name" autocomplete="off"/>
                        </div>
                    </div>
                    <div class="col-md-2 mt-3" *ngIf="checkManagedByFilter">
                        <select2 ngDefaultControl [data]="users" [templates]="template"
                          class="select2" value="" placeholder="Managed by" formControlName="managed_by" (update)="handleSearch('')">
                          <ng-template #template let-data="data">{{data?.name}}</ng-template>
                        </select2>
                    </div>
                    <div class="col-md-3 mt-3">
                        <ng-select ngDefaultControl [items]="properties" class="select2" value="" placeholder="Select Properties"
                            [typeahead]="searchInput$" [virtualScroll]="true" formControlName="property_id" (scrollToEnd)="onScrollToEnd()" (change)="handleSearch('')">
                            <ng-template #template let-data="data">{{data?.name}}</ng-template>
                        </ng-select>
                    </div>
                    <div class="col-md-3 mt-3">
                        <select class="form-select" formControlName="inspection_type" (change)="handleSearch('')">
                            <option data-display="Select" value="null" selected>Select Type</option>
                            <option value="Move In">Move In</option>
                            <option value="Move Out">Move Out</option>
                            <option value="Q1">Q1</option>
                            <option value="Q2">Q2</option>
                            <option value="Q3">Q3</option>
                            <option value="Q4">Q4</option>
                            <option value="Quarterly Inspection">Quarterly Inspection</option>
                        </select>
                    </div>
                    <div class="col-md-2 mt-3">
                        <select class="form-select" formControlName="inspection_status" (change)="handleSearch('')">
                            <option data-display="Select" value="null" selected>Select Status</option>
                            <option value="In Progress">In Progress</option>
                            <option value="Submitted">Submitted</option>
                            <option value="Owner Review">Owner Review</option>
                            <option value="Tenant Review">Tenant Review</option>
                            <option value="Completed">Completed</option>
                        </select>
                    </div>
                    <div class="col-md-1 mt-3">
                        <button class="btn btn-danger btn-sm float-end" type="button" (click)="resetSearchForm()" [disabled]="!disableClear">Clear</button>
                    </div>
                    <!-- <div class="col-md-1 mt-4 p-0">
                        <button class="btn btn-primary btn-sm  float-start" type="submit">Search</button>
                    </div> -->

                </div>
            </form>


                <div class="row">
                        <div class="col-xl-12">
                        <div class="table-responsive active-projects style-1 ItemsCheckboxSec shorting dataTables_wrapper">
                            <table id="empoloyees-tbl" class="table mb-0" matSort (matSortChange)="sortData($event)">
                                <thead>
                                    <tr>
                                        <th mat-sort-header="property_name">Property</th>
                                        <th  mat-sort-header="inspection_name">Inspection Name</th>
                                        <th  mat-sort-header="schedule_start_date">Schedule Date</th>
                                        <th  mat-sort-header="schedule_end_date">Completed Date</th>
                                        <!-- <th  mat-sort-header="inspection_type">Inspection Type</th> -->
                                        <!-- <th>No Of Days</th>
                                        <th>Target Date</th> -->
                                        <!-- <th>Files</th>                                         -->
                                        <th  mat-sort-header="inspection_status">Status</th>
                                        <th class="text-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @for(item of allData.data; track item.id){
                                    <tr>
                                        <td>
                                            <a class="text-primary"
                                              [routerLink]="['/admin/properties/property-view', item.property_id, 1]"
                                            >
                                              {{ item.property_name }}
                                            </a>
                                        </td>
                                        <td>{{ item.inspection_name }}</td>
                                        <td>{{ item.schedule_start_date | date:'dd-MM-yyyy' }}</td>
                                        <td>{{ item.schedule_end_date | date:'dd-MM-yyyy' }}</td>
                                        <!-- <td>
                                            <span>{{ item.inspection_type }}</span>
                                        </td> -->
                                        <!-- <td>{{ item.inspection_days }}</td>
                                        <td>
                                            <span>{{ item.target_end_date }}</span>
                                        </td> -->
                                        <!-- <td>
                                            <span>{{ item.files }}</span>
                                        </td>      -->
                                        <td>
                                            @if(item.inspection_status == 'In Progress'){
                                            <span class="badge badge-danger light border-0">{{item.inspection_status}}</span>
                                            } @else if(item.inspection_status == 'Submitted'){
                                            <span class="badge badge-info light border-0">{{item.inspection_status}}</span>
                                            }@else if(item.inspection_status == 'Owner Review'){
                                            <span class="badge badge-primary light border-0">{{item.inspection_status}}</span>
                                            }@else if(item.inspection_status == 'Tenant Review'){
                                            <span class="badge badge-secondary light border-0">{{item.inspection_status}}</span>
                                            }@else {
                                            <span class="badge badge-success light border-0">{{item.inspection_status}}</span>
                                            }
                                        </td>

                                        <td class="text-center">
                                        <!-- <span class="badge badge-success light border-0 m-1 c-pointer" (click)="openCenter(content)">Update Status</span>
                                        <span class="badge badge-success light border-0 m-1 c-pointer" (click)="selectTicket(item)">Edit</span>
                                        <span class="badge badge-danger light border-0">Delete</span> -->
                                        <div class="img-wrapper" *ngIf="checkEditInspection && (!isClosed(item.inspection_status) || displayInspectionEdit)">
                                            <button type="button" class="btn btn-success shadow btn-xs sharp mb-1 me-2" (click)="editInspection(item.id)"><i class="fa fa-edit"></i></button>
                                            <div class="tooltip-text">Edit</div>
                                        </div>
                                        <div class="img-wrapper" *ngIf="checkCreateInspection && item.inspection_status == 'In Progress'">
                                            <button type="button" class="btn btn-primary shadow btn-xs sharp mb-1 me-2" (click)="viewInspection(item.id)"><i class="fa fa-plus"></i></button>
                                            <div class="tooltip-text">Manage Inspection</div>
                                        </div>
                                        <div class="img-wrapper" *ngIf="isClosed(item.inspection_status)">
                                            <button type="button" class="btn btn-info shadow btn-xs sharp mb-1 me-2" (click)="editInspection(item.id, true)"><i class="fa fa-eye"></i></button>
                                            <div class="tooltip-text">View</div>
                                        </div>
                                        <div class="img-wrapper" *ngIf="inspectionReportView">
                                            <button type="button" class="btn btn-info shadow btn-xs sharp mb-1 me-2" (click)="inspectionReport(item.id, item.property_id)"><i class="fa fa-book"></i></button>
                                            <div class="tooltip-text">Report</div>
                                        </div>
                                        <div class="img-wrapper" *ngIf="inspectionDownloadView">
                                            <button type="button" class="btn btn-warning shadow btn-xs sharp mb-1 me-2" (click)="viewInspectionPDF(item.id)"><i class="fa fa-download"></i></button>
                                            <div class="tooltip-text">Download</div>
                                        </div>
                                        <div class="img-wrapper" *ngIf="checkDeleteInspection && !isClosed(item.inspection_status)">
                                            <button type="button" class="btn btn-danger shadow btn-xs sharp mb-1 me-2" (click)="deleteInspection(item.id)"><i class="fa fa-trash"></i></button>
                                            <div class="tooltip-text">Delete</div>
                                        </div>
                                        </td>
                                    </tr>
                                    }
                                </tbody>
                            </table>
                            <div class="dataTables_info" id="example5_info" role="status" aria-live="polite" *ngIf="allData.data?.length">Showing {{allData.startPage}} to
                            {{allData.endPage}} of {{ totalPage }} entries
                        </div>
                            <div class="dataTables_paginate paging_simple_numbers pt-2">
                                <app-pagination [totalPage]="pageCount" [page]="page" (newPage)="pageChange($event)"></app-pagination>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div #addTicketButton class="offcanvas offcanvas-end customeoff {{ ticketadd_edit ? 'show':''}}" tabindex="-1" id="ticketadd_edit" data-bs-backdrop="static">
    <div class="offcanvas-header">
    <h5 class="modal-title" id="#gridSystemModal"> {{ isEditInspection ? 'Edit' : isInspectionView ? 'View' : 'Add'}} Inspection</h5>
      <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"  (click)="tikcetClose()">
          <i class="fa-solid fa-xmark"></i>
      </button>
    </div>
    <div class="offcanvas-body">
      <div class="container-fluid" >
      <form [formGroup]="addInspectionForm" (ngSubmit)="onSubmit()" autocomplete="off">
        <div class="row">
            <div class="col-xl-12 mb-3">
                <label for="exampleFormControlInput1-1" class="form-label">Select Property<span class="text-danger">*</span></label>
                <ng-select ngDefaultControl [items]="properties"
                    class="select2" value="" placeholder="Select Properties"
                    [typeahead]="searchInput$" [virtualScroll]="true"
                    formControlName="property_id" (scrollToEnd)="onScrollToEnd()">
                    <ng-template #template let-data="data">{{data?.name}}</ng-template>
                </ng-select>
                <div *ngIf="addInspectionForm?.get('property_id')?.invalid && addInspectionForm?.get('property_id')?.touched" class="required">
                   Property is required
                </div>
              </div>
          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-1" class="form-label">Inspection Name<span class="text-danger">*</span></label>
            <input type="text" class="form-control" id="exampleFormControlInput1-3" placeholder="Move In Inspection" formControlName="inspection_name">
            <div *ngIf="addInspectionForm?.get('inspection_name')?.invalid && addInspectionForm?.get('inspection_name')?.touched" class="required">
               Inspection name is required
            </div>
          </div>
          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-2" class="form-label">Inspection Type<span class="text-danger">*</span></label>
            <select class="form-select" formControlName="inspection_type">
                <option  data-display="Select" value="null" selected>Select Type</option>
                <option value="Move In">Move In</option>
                <option value="Move Out">Move Out</option>
                <option value="Q1">Q1</option>
                <option value="Q2">Q2</option>
                <option value="Q3">Q3</option>
                <option value="Q4">Q4</option>
                <option value="Quarterly Inspection">Quarterly Inspection</option>
            </select>
            <div *ngIf="addInspectionForm?.get('inspection_type')?.invalid && addInspectionForm?.get('inspection_type')?.touched" class="required">
               Inspection type is required
            </div>
          </div>
          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-3" class="form-label">Schedule Date</label>
            <input type="date" class="form-control" id="exampleFormControlInput1-3" placeholder="select date" formControlName="schedule_start_date">
          </div>
          <div class="col-xl-6 mb-3">
              <label for="exampleFormControlInput1-4" class="form-label">Completed Date</label>
              <input type="date" class="form-control" id="exampleFormControlInput1-3" placeholder="select date" formControlName="schedule_end_date" [min]="addInspectionForm.get('schedule_start_date')?.value">
          </div>
          <div class="col-xl-6 mb-3">
              <label for="exampleFormControlInput1-4" class="form-label">Notes</label>
              <textarea type="text" class="form-control" id="exampleFormControlInput1-3" placeholder="Notes" formControlName="inspection_notes"></textarea>
          </div>
          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-4" class="form-label">Choose File(s)</label>
            <input type="file" class="form-control" id="exampleFormControlInput1-3" multiple formControlName="files" (change)="uploadImages($event)">
          </div>
          <div class="col-xl-6 mb-3" *ngIf="isEditInspection">
            <label for="exampleFormControlInput1-2" class="form-label">Inspection Status</label>
            <select class="form-select" formControlName="inspection_status">
                <option  data-display="Select" value="null" selected>Select Status</option>
                <option value="In Progress">In Progress</option>
                <option value="Submitted">Submitted</option>
                <option value="Owner Review">Owner Review</option>
                <option value="Tenant Review">Tenant Review</option>
                <option value="Completed">Completed</option>
            </select>
          </div>

          <div class="col-xl-12 mb-3" *ngIf="uploadedImages?.length && (isEditInspection || isInspectionView)">
        <div *ngFor="let img of uploadedImages; let i = index">
          <div class="row">
            <div class="col-md-9">
              <p class="badge light badge-light"> {{ img.original_name }} </p>
            </div>
            <div class="col-md-3">
              <p class="badge light badge-primary me-3 ms-3 c-pointer" (click)="viewImage(img.url)"> View </p>
              <p *ngIf="isEditInspection" class="badge light badge-danger c-pointer" (click)="deleteImage(img.id)"> Delete </p>
            </div>
          </div>
        </div>
      </div>

      </div>
              <div>
                  <button *ngIf="!isInspectionView" class="btn btn-primary ms-1 me-3" type="submit" [disabled]="addInspectionForm.invalid || loadingService.isLoading()">Submit</button>
                  <button class="btn btn-danger lightme-1 float-end" type="button" data-bs-dismiss="offcanvas" aria-label="Close"  (click)="tikcetClose()">Close</button>
              </div>
      </form>
        </div>
    </div>
  </div>
  @if(ticketadd_edit){
    <div class="offcanvas-backdrop fade show" (click)="ticketPopupOpen()"></div>
  }

  <ng-template #content let-modal>
    <form [formGroup]="updateStatusForm" (ngSubmit)="updateStatus()" autocomplete="off">
    <div class="modal-header">
      <h5 class="modal-title">Update Status</h5>
      <button type="button" class="btn-close" (click)="closeModal()"></button>
    </div>
    <div class="modal-body">
            <h6>Status</h6>
            <select class="form-control" formControlName="update_status">
                <option value="" selected disabled>Update Status</option>
                <option value="Pending">Pending</option>
                <option value="In-progress">In-Progress</option>
            </select>
            <div *ngIf="updateStatusForm?.get('update_status')?.invalid && updateStatusForm?.get('update_status')?.touched" class="required">
                Status is required
            </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-danger btn-sm" (click)="closeModal()">Close</button>
        <button type="button" class="btn btn-primary btn-sm" [disabled]="updateStatusForm.invalid || loadingService.isLoading()">Save</button>
    </div>
    </form>
</ng-template>
